export default __webpack_public_path__ + "static/media/otros_efectos.5232df47.png";